// Log/Debug
export const SET_TEST_LEVEL = 'setTestLevel';
export const SET_SENTRY = 'setSentry';

// Configs
export const SET_GLOBAL_CONFIG = 'setGlobalConfig';
export const SET_AFFILIATE_CONFIG = 'setAffiliateConfig';
export const SET_JOURNEY_CONFIG = 'setJourneyConfig';
export const SET_LOCAL_CONFIG = 'setLocalConfig';

// User
export const SET_LOCALE = 'setLocale';
export const SET_SF_ID = 'setSfId';
export const SET_CUSTOMER_NUMBER = 'setCustomerNumber';

// Already services
export const SET_USER_ALREADY_INITIALIZED = 'setUserAlreadyMapInitialized';
export const SET_USER_ALREADY_MAP = 'setUserAlreadyMap';
export const SET_ALREADY_CLICKED_CHECKED = 'setAlreadyClickedChecked';

// Tracking
export const SET_TRACKING_CODE = 'setTrackingCode';
export const SET_CAMPAIGN_CODE = 'setCampaignCode';
export const SET_EXTERNAL_PARTNER_ID = 'setExternalPartnerId';
export const SET_LEAD_TRACKING_CODE = 'setLeadTrackingCode';

// Parameters
export const SET_MB_PARAMS = 'setMbParams';
export const SET_MARKETING_CLOUD_PARAMS = 'setMarketingCloudParams';

// Payments / Palyance
export const SET_PAYMENT_METHOD = 'setPaymentMethod';
export const SET_PAYMENT_ID = 'setPaymentId';
export const SET_MANDATE_ID = 'setMandateId';
export const SET_RECAPTURE_IDENTIFIER = 'setRecaptureIdentifier';
export const SET_RESUBMIT = 'setResubmit';
export const SET_PAYMENT_ACCOUNT_IDENTIFIER = 'setPaymentAccountIdentifier';
export const SET_PAYMENT_WALLET_UID = 'setWalletUid';
export const SET_FALLBACK_PAYMENT = 'setFallbackPayment';
export const SET_CURRENT_ORDER_UID = 'setCurrentOrderUid';
export const SET_ASPSP_EMAIL = 'setAspspEmail';
export const SET_ASPSP_FULL_ADDRESS = 'setAspspFullAddress';

export const SET_ISDISTINCT_ADRESS = 'setIsDistinctAddress';
export const SET_IS_ASPSP_PREFILL_EDITED_BY_USER = 'setisAspspPrefillEditedByUser';
export const SET_IS_ASPSP_ELIGIBLE = 'setIsAspspEligible';
export const SET_IS_ASPSP_ELIGIBLE_BANK_CARD = 'setIsAspspEligibleBankCard';
export const SET_IS_ASPSP_ELIGIBLE_SEPA = 'setIsAspspEligibleSepa';
export const SET_ASPSP_PAYMENT_INFORMATIONS = 'setAspspPaymentInformations';
export const SET_DOUBLE_OPTIN = 'setDoubleOptin';
export const SET_PCI_TOKEN = 'setPciToken';
export const SET_HOLDER_NAME = 'setHolderName';

export const SET_COUNTRIEXCLUDED = 'setCountriesExcluded';

// Choices
export const SET_CHOICES = 'setChoices';

// Contact form
export const SET_FORM_IS_VALID = 'setFormIsValid';
export const SET_USE_SAME_ADDRESS_FOR_SHIPPING = 'setUseSameAddressForShipping';
export const SET_FORM_DATA = 'setFormData';
export const SET_CONDITIONS_APPROVED = 'setConditionsApproved';
export const SET_CGS_APPROVED = 'setCgsApproved';
export const SET_PREFILL_DATA = 'setPrefillData';
export const SET_PREFILL_DATA_RAW = 'setPrefillDataRaw';
export const SET_BILLING_COUNTRY = 'setBillingCountry';
export const SET_SHIPPING_COUNTRY = 'setShippingCountry';

// Order
export const SET_ORDERS_DATA = 'setOrdersData';
export const SET_ORDER_DRAFT_SENT = 'setOrderDraftSent';
export const SET_ORDER_COMPLETE = 'setOrderComplete';
export const SET_IS_PREVIOUS_ORDER_CANCELLED = 'setIsPreviousOrderCancelled';
export const SET_IS_PREVIOUS_ORDER_EXPIRED = 'setIsPreviousOrderExpired';
export const SET_PREVIOUS_EXTERNAL_ORDER_ID = 'setPreviousExternalOrderId';
export const HAS_1_CLICK_OPT_OUT = 'has1ClickOptOut';

export const SET_CANCEL_PREVIOUS_ORDER = 'setCancelPreviousOrder';

export const SET_COREGS = 'setCoregs';

export const SET_CURRENT_PAGE_ID = 'setCurrentPageId';
export const SET_PREVIOUS_PAGE_ID = 'setPreviousPageId';



// WEBPACK FOOTER //
// ./src/common/store/mutations.js